import Vue from "vue";
import Vuetify, {
  VApp,
  VContainer,
  VLayout,
  VFlex,
  VSpacer,
  VMenu,
  VCard,
  VList,
  VBtn,
  VToolbar,
  VFooter,
} from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import nl from "vuetify/src/locale/nl";

Vue.use(Vuetify, {
  // Disabled due to compatibility problems with IE11
  // options: {
  //   customProperties: true
  // },
  components: {
    VApp,
    VContainer,
    VLayout,
    VFlex,
    VSpacer,
    VMenu,
    VCard,
    VList,
    VBtn,
    VToolbar,
    VFooter,
  },
  theme: {
    primary: "#181E3C",
    secondary: "#17a2b8",
    accent: "#e68425",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#fb8c00",
  },
  // iconfont: 'fa',
  lang: {
    locales: { nl },
    current: "nl",
  },
});
